var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.502.66C1.917.042 1.025.042.44.66a1.569 1.569 0 0 0 0 2.177l6.027 6.36-6.027 6.36a1.568 1.568 0 0 0 0 2.176c.135.143.282.262.456.344.176.082.365.12.576.12.21 0 .4-.038.575-.12.174-.082.321-.201.456-.344l7.059-7.448a1.568 1.568 0 0 0 0-2.177L2.502.66Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.8610e8472eba81ee535adf9edd865dd2.svg";
export { ForwardRef as ReactComponent };